import api from "../services/api";

import { IEntradas, ISearchRequest, ISearchResponse } from "../interfaces";

export interface IEntradasListModel {
    id: string;
    dataComprovante: string;
    gerenteRegional: string;
    gerenteSetor: string;
    representante: string;
    valorEntrada: number;
    observacao: string;

}

interface IEntradaResponse {
    entrada: IEntradas;
    message: string;
}

class PaymentsRepository {
    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IEntradasListModel>> => {
        const response = await api.get<ISearchResponse<IEntradasListModel>>("entradas", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });
        return response.data;
    }

    public Insert = async (data: FormData): Promise<IEntradaResponse> => {
        const response = await api.post<IEntradaResponse>("entradas", data);
        return response.data;
    }

    public GetById = async (id: string): Promise<IEntradas> => {
        const response = await api.get<IEntradas>(`entradas/${id}`);

        return response.data;
    }

    public Delete = async (id: string): Promise<void> => {
        await api.delete(`entradas/${id}/deletar`);
    }
}

const paymentsRepository = new PaymentsRepository();
export default paymentsRepository;
